import { SortBy } from "../config/type";

export const isRateColumn = (
  column: unknown,
): column is { selectType: unknown; } => {
  if (!column || typeof column !== 'object' || !('selectType' in column)) return false;

  return ['dod', 'sdlw', 'change'].includes(column?.selectType as string);
};

export const isRateSort = (sorts: SortBy | SortBy[]) => {
  if (!sorts || (Array.isArray(sorts) && sorts?.length === 0)) return false;

  const sort = Array.isArray(sorts) ? sorts[0] : sorts;

  return sort.order as string === 'asc_by_rate' || sort.order as string === 'desc_by_rate';
};

/**
 * 仅在后端支持的报表开放“↑按变化率升序”和“↓按变化率降序”
 * 支持范围：
 * 总览（日报周报月报各版本，含去小号、V2、V3等版本）、收入类的报表（sales相关）
 */
export const isRateSortSupportedPath = (pathName: string) => {
  const path = pathName ?? '';
  if (!path.startsWith('/dashboard/')) return false;

  const allowPatterns = [
    /overview\/[^/]*(daily|weekly|monthly|lifetime|pcConsoleWeek|pcConsoleMonth)[^/]*/i,
    /monetization\/(revenue|ltv|salesOverview|salesBreakdown|inGameRevenue|inGameRevenueMerge)(?:-tencent)?(?:\/|$)/i,
  ];

  return allowPatterns.some((allowPattern) => allowPattern.test(path));
};
